import { render, staticRenderFns } from "./TableEditDataTable.vue?vue&type=template&id=6748b711"
import script from "./TableEditDataTable.vue?vue&type=script&lang=js"
export * from "./TableEditDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports